export default "__VITE_ASSET__40be94ea__"